import React from 'react';
import {
  IconButton,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogContent,
  Box,
  DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialog } from 'theme/index';

const DashboardOnboarding = (props: { isOpen: boolean; handleModalClose: () => void }) => {
  const { isOpen, handleModalClose } = props;

  return (
    <StyledDialog
      open={isOpen}
      onClose={handleModalClose}
      maxWidth='lg'
      aria-describedby='alert-dialog-description'
      scroll='paper'
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
            onClick={handleModalClose}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant='h1' gutterBottom>
            Next Steps
          </Typography>
          <Grid container spacing={2} sx={{ mt: 2 }} textAlign={'center'}>
            <Grid item xs={12} sm={6} md={3}>
              <img src='/images/dashwork4.png' alt='work1' />
              <Typography variant='h3' gutterBottom>
                <IconButton
                  sx={{
                    fontSize: '16px',
                    color: '#FFF',
                    backgroundImage: 'url("images/Ellipse 1.svg")',
                    backgroundSize: 'auto auto',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  1
                </IconButton>
                &nbsp; Complete Profile
              </Typography>
              <Typography variant='body1' gutterBottom>
                Provide demographic and guardian information. 
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <img src='/images/dashwork1.png' alt='work2' />
              <Typography variant='h3' gutterBottom>
                <IconButton
                  sx={{
                    fontSize: '16px',
                    color: '#FFF',
                    backgroundImage: 'url("images/Ellipse 1.svg")',
                    backgroundSize: 'auto auto',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  2
                </IconButton>
                &nbsp; Sign Consent Forms
              </Typography>
              <Typography variant='body1' gutterBottom>
                Review and sign required consent and policy forms. 
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                  component="img"
                  src="/images/Family_Icon.png"
                  alt="work3"
                  sx={{
                    width: 120,
                    height: 130,
                    objectFit: 'contain',
                    transform: 'scale(0.85)',
                  }}
                />
              <Typography variant='h3' gutterBottom>
                <IconButton
                  sx={{
                    fontSize: '16px',
                    color: '#FFF',
                    backgroundImage: 'url("images/Ellipse 1.svg")',
                    backgroundSize: 'auto auto',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  3
                </IconButton>
                &nbsp;Provide Medical & Family History
              </Typography>
              <Typography variant='body1' gutterBottom>
                Share information about child&apos;s health, development, and background. 
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                  component='img'
                  src='/images/Brain_icon.png'
                  alt='work3'
                  sx={{
                    width: 120,
                    height: 130,
                    objectFit: 'contain',
                    transform: 'scale(0.85)',
                  }}
                />
              <Typography variant='h3' gutterBottom>
                <IconButton
                  sx={{
                    fontSize: '16px',
                    color: '#FFF',
                    backgroundImage: 'url("images/Ellipse 1.svg")',
                    backgroundSize: 'auto auto',
                    backgroundRepeat: 'no-repeat',
                  }}
                >
                  4
                </IconButton>
                &nbsp; Take M-Wise
              </Typography>
              <Typography variant='body1' gutterBottom>
                Take our interactive assessment of your child&apos;s psychiatric symptoms
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          fullWidth
          type='submit'
          sx={{ mt: 2, mb: 4, maxWidth: '360px' }}
          onClick={handleModalClose}
        >
          Let&apos;s go
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

DashboardOnboarding.propTypes = {};

export default DashboardOnboarding;
